module.exports = __webpack_public_path__ + "assets/img/xt.ab758b25.svg";